<template>
  <div class="layout-flex">
    <div class="layout-flex-2 layout-flex-child-2">
      <div>
        <div class="item-title">
          <div class="item-line">
            <img class="item-iconTit" src="../../assets/meb/imgs/iconTit@2x.png" />
            {{listObj.title}}
          </div>
        </div>
        <div class="item-dec">{{listObj.dec}}</div>
      </div>
      <div class="item-img-content">
        <img class="item-img" :src="listObj.imageurl" style="height: 100%;"/>
      </div>
    </div>
    <div class="layout-flex-1 layout-flex-child-1">
      <div class="item" v-for="(item,index) in listObj.imgs" :key="index">
        <div>
          <img class="item-img" :src="item.imageurl" />
        </div>
        <div class="item-model" style="background: #000000;opacity: 0.7;"></div>
        <div class="item-model">
          <div class="item-title">{{item.title}}</div>
          <div class="item-line"></div>
          <div class="item-dec">{{item.dec}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contentVideo from "./contentVideo.vue";
import contentImage from "./contentImage.vue";
export default {
  components: {
    contentVideo,
    contentImage
  },
  props: ["list"],
  data() {
    return {
      listObj: this.list
    };
  },
  mounted() {
    console.log(this.listObj);
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.layout-flex {
  width: 1200px;
  background: #ffffff;
  padding: 49px 60px 49px 68px;
  box-sizing: border-box;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  .layout-flex-1 {
    width: 563px;
    height: 353px;
  }
  .layout-flex-2 {
    margin-right: 83px;
    width: 425px;
    height: 353px;
  }
}

.layout-flex-child-2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .item-line {
    float: left;
    border-bottom: 3px solid rgba(40, 132, 244, 0.2);
  }
  .item-iconTit {
    width: 16px;
    height: 22px;
    padding-right: 10px;
  }
  .item-title {
    height: 30px;
    line-height: 20px;
    font-size: 20px;
    font-weight: 400;
    color: #0077c8;
  }
  .item-dec {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    margin-top: 23px;
  }
  .item-img-content {
    height: 224px;
  }
  .item-img {
    width: 100%;
  }
}

.layout-flex-1 {
  .item {
    width: 270px;
    height: 165px;
    position: relative;
  }
  .item-model {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    margin: 23px 34px;
    width: 203px;
    height: 120px;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
  }
  :hover .item-model {
    display: block;
  }
  .item-title {
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    line-height: 21px;
    text-align: center;
  }
  .item-dec {
    font-size: 11px;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
  .item-line {
    width: 30px;
    height: 2px;
    background: #ffffff;
    margin: 2px auto;
  }
  .item-img {
    width: 100%;
  }
}

.layout-flex-child-1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
}

@media screen and (min-width: 1600px) {
  .layout-flex {
    width: 1600px;
    .layout-flex-1 {
      width: 730px;
      height: 450px;
    }
    .layout-flex-2 {
      margin-left: 83px;
      width: 576px;
      height: 450px;
    }
  }

  .layout-flex-child-2 {
    .item-title {
      font-size: 24px;
    }
    .item-dec {
      font-size: 16px;
      line-height: 28px;
    }
    .item-img-content {
      height: 303px;
    }
  }

  .layout-flex-1 {
    .item {
      width: 360px;
      height: 220px;
    }
    .item-model {
      width: 292px;
      height: 174px;
    }
    .item-title {
      font-size: 24px;
    }
    .item-dec {
      font-size: 14px;
      line-height: 22px;
    }
    .item-line {
      width: 40px;
      height: 3px;
      margin: 10px auto;
    }
  }
}
</style>
